import Container from "@/components/Container/Container.tsx";
import { ModalProps } from "@/components/Modal/ModalProps.ts";
import { useShadowRoot } from "@/helpers/ShadowRootContext.ts";
import { useEffect } from "react";
import ReactDOM from "react-dom";

const Modal = ({ children, isOpen, onClose }: ModalProps) => {
  const { shadowRoot, containerEl } = useShadowRoot();

  useEffect(() => {
    if (!isOpen) return;
    const el = document.documentElement;
    const count = parseInt(el.dataset.beModalsOpen ?? "0", 10);
    el.dataset.beModalsOpen = String(count + 1);
    if (count === 0) {
      el.classList.add("be-modal-open");
      document.body.classList.add("be-modal-open");
    }
    return () => {
      const next = parseInt(el.dataset.beModalsOpen ?? "1", 10) - 1;
      el.dataset.beModalsOpen = String(Math.max(0, next));
      if (next <= 0) {
        el.classList.remove("be-modal-open");
        document.body.classList.remove("be-modal-open");
      }
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const handleOutsideClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest(".acc-preview-modal-content")) {
        onClose();
      }
    };

    const timeoutId = setTimeout(() => {
      shadowRoot.addEventListener("mousedown", handleOutsideClick as EventListener);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      shadowRoot.removeEventListener("mousedown", handleOutsideClick as EventListener);
    };
  }, [onClose, isOpen, shadowRoot]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      <div className="acc-preview-modal-overlay c-accommodation-preview-modal-overlay"></div>
      <div className="acc-preview-modal-content c-accommodation-preview-modal">
        <Container>{children}</Container>
      </div>
    </>,
    containerEl,
  );
};

export default Modal;
